<template>
  <div>
    <div class="wz-page-header">
      <h1 class="wz-page-title">CTS</h1>
    </div>

    <wz-table-container>
      <wz-table-toolbar>
        <template #left>
          <div style="min-width: 320px; flex-shrink: 0">
            <wz-select
              label="Empresa"
              v-model="companyId"
              :items="companies"
              defaultOption="Seleccione una empresa"
              @change="loadData"
            />
          </div>
          <div style="min-width: 140px; flex-shrink: 0">
            <wz-select
              label="Año"
              v-model="year"
              :items="years"
            />
          </div>
          <div style="min-width: 160px; flex-shrink: 0">
            <wz-select
              label="Estado"
              v-model="statusFilter"
              :items="statusOptions"
              defaultOption="Todos"
            />
          </div>
        </template>

        <template #right>
          <wz-tooltip text="Recargar">
            <wz-button variant="outline" @click="loadData()">
              <i class="ri-loop-right-line"></i>
            </wz-button>
          </wz-tooltip>
          <wz-button variant="primary" @click="$router.push({ name: 'cts-calculate' })">
            <i class="ri-calculator-line mr-1"></i>Calcular CTS
          </wz-button>
        </template>
      </wz-table-toolbar>

      <wz-table>
        <thead>
          <tr>
            <th>Período</th>
            <th>Empresa</th>
            <th class="text-center">Colaboradores</th>
            <th class="text-right">Monto total</th>
            <th class="text-center">Estado</th>
            <th>Fecha de cálculo</th>
            <th class="text-center">Opciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="o in filteredList" :key="o.id">
            <td>{{ periodLabel(o.periodType) }} {{ o.periodYear }}</td>
            <td>{{ o.companyName || '-' }}</td>
            <td class="text-center">{{ o.totalEmployees != null ? o.totalEmployees : '-' }}</td>
            <td class="text-right">
              <span v-decimal:pen="o.totalAmount" v-if="o.totalAmount != null"></span>
              <span v-else>-</span>
            </td>
            <td class="text-center">
              <wz-badge :variant="statusVariant(o.status)" pill>{{ statusLabel(o.status) }}</wz-badge>
            </td>
            <td v-local-date="o.calculatedAt"></td>
            <td class="text-center">
              <wz-button variant="outline" size="sm" @click="$router.push({ name: 'cts-detail', params: { id: o.id } })">Ver detalle</wz-button>
            </td>
          </tr>
        </tbody>
      </wz-table>

      <wz-table-footer>
        <div class="table-no-results" v-if="!filteredList.length">
          <p class="m-0 px-3">
            {{ companyId ? 'No se encontraron períodos.' : 'Seleccione empresa y año para ver los períodos.' }}
          </p>
        </div>
      </wz-table-footer>
    </wz-table-container>
  </div>
</template>

<script>
import { Alert } from '@wizepe/wizeui'
import { CtsService, CompanyService } from '@/core/services'
import { Constants } from '@/core/utils'

export default {
  data() {
    const currentYear = new Date().getFullYear()
    return {
      companyId: null,
      companies: [],
      year: currentYear,
      years: Array.from({ length: 7 }, (_, i) => {
        const y = currentYear + 1 - i
        return { key: y, label: String(y) }
      }),
      statusFilter: null,
      statusOptions: Object.values(Constants.CtsStatus).map(s => ({ key: s.key, label: s.label })),
      list: [],
    }
  },
  computed: {
    filteredList() {
      return this.list.filter(o => {
        if (this.year && o.periodYear !== this.year) return false
        if (this.statusFilter && o.status !== this.statusFilter) return false
        return true
      })
    },
  },
  methods: {
    periodLabel(type) {
      const t = Constants.CtsPeriodType[type]
      return t ? t.label.split(' —')[0] : type
    },
    statusLabel(status) {
      const s = Constants.CtsStatus[status]
      return s ? s.label : status
    },
    statusVariant(status) {
      const s = Constants.CtsStatus[status]
      return s ? s.color : 'dark'
    },
    async loadData() {
      if (!this.companyId) { this.list = []; return }
      try {
        this.$store.dispatch('app/loading', true)
        const resp = await CtsService.getPeriods(this.companyId)
        this.list = resp.payload || []
      } catch (e) {
        console.error(e)
        Alert.error(e.errors ? e.errors.message : 'Error al cargar los períodos')
      } finally {
        this.$store.dispatch('app/loading', false)
      }
    },
    async loadCompanies() {
      try {
        const resp = await CompanyService.listAll()
        this.companies = (resp.payload || []).map(c => ({ key: c.id, label: c.name }))
      } catch (e) {
        console.error(e)
      }
    },
  },
  async created() {
    await this.loadCompanies()
  },
}
</script>
